import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { SupportFaqModel } from "./SupportFaqModel";
import { themeService } from "../../core/NotificationStripNav/ThemeService";
import { Theme } from "../../core/Models/CustomSiteConfigModel";

import "./SupportFaq.css";

const SupportFaq: React.FC<{ blok: SupportFaqModel }> = ({ blok }) => {
  const [theme, setTheme] = useState<Theme | null>(themeService.getTheme());
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = themeService.subscribe(setTheme);
    return () => unsubscribe();
  }, []);

  const faq = blok?.content?.body ? blok.content.body[0] : null;
  if (!faq) {
    return null;
  }

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (blok.full_slug) {
      navigate(`/${blok.full_slug}`);
    }
  };

  return (
    <div
      className="support-faq"
      style={{
        backgroundColor: theme?.containerColor,
        color: theme?.textColor,
      }}
      onClick={handleClick}
    >
      <div className="journey-title" title={faq.title}>
        {faq.title}
      </div>
      <div className="journey-description" title={faq.subtitle}>
        {faq.subtitle}
      </div>
      <div className="journey-action">
        {" "}
        <a
          href={`/${blok?.full_slug}`}
          style={{ color: theme?.hyperlinksColor }}
        >
          Read more
        </a>
      </div>
    </div>
  );
};

export default SupportFaq;
